// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hold-cart-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  z-index: 1200;
  display: flex;
  justify-content: flex-end;
}

.hold-cart-aside {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  height: 100vh;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid #cbd5e1;
  background-color: #ffffff;
  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22);
}

@media (min-width: 768px) {
  .hold-cart-aside {
    width: 480px;
  }
}

.hold-cart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));
  padding: 16px 20px;
}

.hold-cart-title-container {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 16px;
}

.hold-cart-title {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #0f172a;
  margin: 0;
}

.hold-cart-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background-color 0.2s;
  border: 1px solid transparent;
  background: none;
  cursor: pointer;
  height: 36px;
  width: 36px;
  border-radius: 9999px;
  color: #64748b;
  padding: 0;
}

.hold-cart-close-btn:hover {
  background-color: #f1f5f9;
}

.hold-cart-close-btn svg {
  width: 16px;
  height: 16px;
}

.hold-cart-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.hold-cart-form-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.hold-cart-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hold-cart-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f172a;
}

.hold-cart-input {
  display: flex;
  height: 36px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background-color: transparent;
  padding: 4px 12px;
  font-size: 1rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
}

.hold-cart-input:focus {
  outline: none;
  border-color: #94a3b8;
  box-shadow: 0 0 0 1px #94a3b8;
}

@media (min-width: 768px) {
  .hold-cart-input {
    font-size: 0.875rem;
  }
}

.hold-cart-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.hold-cart-submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
  cursor: pointer;
  border: 1px solid #0f172a;
  min-height: 36px;
  padding: 8px 16px;
  width: 100%;
  background-color: #0f172a;
  color: #ffffff;
}

.hold-cart-submit-btn:hover {
  background-color: #1e293b;
  border-color: #1e293b;
}

.hold-cart-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.hold-cart-view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
  cursor: pointer;
  border: 1px solid #cbd5e1;
  min-height: 36px;
  padding: 8px 16px;
  width: 100%;
  background-color: #ffffff;
  color: #0f172a;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.hold-cart-view-btn:hover {
  background-color: #f8fafc;
}

.hold-cart-view-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ═══ DARK THEME — HoldCartModal ═══ */
.dark .hold-cart-aside {
  background-color: #1e293b;
  border-left-color: #334155;
}
.dark .hold-cart-header {
  background: linear-gradient(135deg, rgba(30,41,59,0.97), rgba(15,23,42,0.97));
  border-bottom-color: #334155;
}
.dark .hold-cart-title { color: #f1f5f9; }
.dark .hold-cart-close-btn { color: #64748b; }
.dark .hold-cart-close-btn:hover { background-color: #334155; }

.dark .hold-cart-label { color: #cbd5e1; }

.dark .hold-cart-input {
  border-color: #334155;
  color: #f1f5f9;
  background-color: #0f172a;
}
.dark .hold-cart-input:focus {
  border-color: #475569;
  box-shadow: 0 0 0 1px #475569;
}

.dark .hold-cart-view-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #cbd5e1;
}
.dark .hold-cart-view-btn:hover { background-color: #334155; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/HoldCartModal/HoldCartModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,aAAa;EACb,aAAa;EACb,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,yFAAyF;EACzF,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,2CAA2C;EAC3C,wEAAwE;EACxE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,6EAA6E;EAC7E,4BAA4B;AAC9B;AACA,yBAAyB,cAAc,EAAE;AACzC,6BAA6B,cAAc,EAAE;AAC7C,mCAAmC,yBAAyB,EAAE;;AAE9D,yBAAyB,cAAc,EAAE;;AAEzC;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,kCAAkC,yBAAyB,EAAE","sourcesContent":[".hold-cart-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  z-index: 1200;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.hold-cart-aside {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 9999;\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  flex-direction: column;\n  overflow: hidden;\n  border-left: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22);\n}\n\n@media (min-width: 768px) {\n  .hold-cart-aside {\n    width: 480px;\n  }\n}\n\n.hold-cart-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));\n  padding: 16px 20px;\n}\n\n.hold-cart-title-container {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  gap: 16px;\n}\n\n.hold-cart-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #0f172a;\n  margin: 0;\n}\n\n.hold-cart-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: background-color 0.2s;\n  border: 1px solid transparent;\n  background: none;\n  cursor: pointer;\n  height: 36px;\n  width: 36px;\n  border-radius: 9999px;\n  color: #64748b;\n  padding: 0;\n}\n\n.hold-cart-close-btn:hover {\n  background-color: #f1f5f9;\n}\n\n.hold-cart-close-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.hold-cart-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.hold-cart-form-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.hold-cart-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.hold-cart-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.hold-cart-input {\n  display: flex;\n  height: 36px;\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid #cbd5e1;\n  background-color: transparent;\n  padding: 4px 12px;\n  font-size: 1rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  box-sizing: border-box;\n}\n\n.hold-cart-input:focus {\n  outline: none;\n  border-color: #94a3b8;\n  box-shadow: 0 0 0 1px #94a3b8;\n}\n\n@media (min-width: 768px) {\n  .hold-cart-input {\n    font-size: 0.875rem;\n  }\n}\n\n.hold-cart-actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.hold-cart-submit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  cursor: pointer;\n  border: 1px solid #0f172a;\n  min-height: 36px;\n  padding: 8px 16px;\n  width: 100%;\n  background-color: #0f172a;\n  color: #ffffff;\n}\n\n.hold-cart-submit-btn:hover {\n  background-color: #1e293b;\n  border-color: #1e293b;\n}\n\n.hold-cart-submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.hold-cart-view-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  cursor: pointer;\n  border: 1px solid #cbd5e1;\n  min-height: 36px;\n  padding: 8px 16px;\n  width: 100%;\n  background-color: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.hold-cart-view-btn:hover {\n  background-color: #f8fafc;\n}\n\n.hold-cart-view-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ═══ DARK THEME — HoldCartModal ═══ */\n.dark .hold-cart-aside {\n  background-color: #1e293b;\n  border-left-color: #334155;\n}\n.dark .hold-cart-header {\n  background: linear-gradient(135deg, rgba(30,41,59,0.97), rgba(15,23,42,0.97));\n  border-bottom-color: #334155;\n}\n.dark .hold-cart-title { color: #f1f5f9; }\n.dark .hold-cart-close-btn { color: #64748b; }\n.dark .hold-cart-close-btn:hover { background-color: #334155; }\n\n.dark .hold-cart-label { color: #cbd5e1; }\n\n.dark .hold-cart-input {\n  border-color: #334155;\n  color: #f1f5f9;\n  background-color: #0f172a;\n}\n.dark .hold-cart-input:focus {\n  border-color: #475569;\n  box-shadow: 0 0 0 1px #475569;\n}\n\n.dark .hold-cart-view-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #cbd5e1;\n}\n.dark .hold-cart-view-btn:hover { background-color: #334155; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
